import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f0592a',
    },
    secondary: {
      main: '#2a2a2a',
      contrastText: '#fff',
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: [
      "'Montserrat'",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  shape: {
    borderRadius: 0,
  },
  overrides: {
    MuiInput: {
      root: {
        // fontWeight: 300,
      },
    },
    MuiButton: {
      contained: {
        boxShadow: 'none',
      },
    },
    MuiTypography: {
      h6: {
        fontWeight: 500,
      },
    },
    MuiLink: {
      underlineHover: {
        '&:hover': {
          textDecoration: 'none',
        },
      },
      underlineAlways: {
        textDecoration: 'none',
      },
    },
  },
});

export { theme };
